// extracted by mini-css-extract-plugin
export default {"layout":"Gallery_layout__CVcHj","gallery_title":"Gallery_gallery_title__eToer","horizontal":"Gallery_horizontal__Z19Nw","vertical":"Gallery_vertical__xe3+B"};